import { render, staticRenderFns } from "./CreateFolderPage.vue?vue&type=template&id=8bbe89fe&scoped=true"
import script from "./CreateFolderPage.vue?vue&type=script&lang=ts"
export * from "./CreateFolderPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbe89fe",
  null
  
)

export default component.exports